module.exports = __webpack_public_path__ + "static/sample-projects-20-2888bbb88b0e1bcb8da0e474e474f745.png";